import { useApiClient } from '@m43/core';
import { QueryResultIdentifier, UpdateToEventEntity, UpdateToEventResource } from '@mark43/cad-api';

export default () => {
    const apiClient = useApiClient();

    const getUpdateToEventBootstrap = async ({
        eventId,
        dexIncomingMessageId,
        outgoingMessageId,
    }: {
        eventId?: number;
        dexIncomingMessageId?: number;
        outgoingMessageId?: number;
    }) => {
        return await apiClient.request<UpdateToEventResource.UpdateToEventBootstrap>({
            data: { eventId, dexIncomingMessageId, outgoingMessageId },
            method: 'POST',
            url: 'update_to_event/bootstrap',
        });
    };

    const getUpdateToEventBatchBootstrap = async ({
        eventId,
        queryResultIdentifiers,
    }: {
        eventId?: number;
        queryResultIdentifiers: QueryResultIdentifier[];
    }) => {
        return await apiClient.request<UpdateToEventResource.UpdateToEventBatchBootstrap>({
            data: { eventId, queryResultIdentifiers },
            method: 'POST',
            url: 'update_to_event/batch/bootstrap',
        });
    };

    const postUpdateToEventUpdate = async (
        eventId: number,
        eventPerson?: UpdateToEventEntity,
        eventVehicle?: UpdateToEventEntity,
        parsedPerson?: UpdateToEventEntity,
        parsedVehicle?: UpdateToEventEntity
    ) => {
        const response = await apiClient.request<UpdateToEventResource.UpdateToEventUpdate>({
            data: { eventId, eventPerson, eventVehicle, parsedPerson, parsedVehicle },
            method: 'POST',
            url: 'update_to_event/update',
        });

        const success = response.data.success;

        if (!success) {
            throw Error(`Failed to update entities on eventId ${eventId}.`);
        }

        return success;
    };

    return {
        getUpdateToEventBootstrap,
        getUpdateToEventBatchBootstrap,
        postUpdateToEventUpdate,
    };
};
